import {call} from "./api";

export const all = params => {
  return call(client => {
    return client.get(`/transcodemodes`, params)
  })
};



// WEBPACK FOOTER //
// ./src/api/transcodeMode.js